import React from "react";
import Modal from "../../../../components/Modal";
import "./index.scss";

const RequireKycModal = ({ isOpen, onClose, onConfirm, onCancel }) => {
  return (
    <Modal
      isOpen={isOpen}
      onClose={onCancel}
      title="Confirm KYC Selection"
      size="medium"
    >
      <div className="require-kyc-modal-content">
        <div className="warning-icon">
          <svg
            width="64"
            height="64"
            viewBox="0 0 24 24"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M12 2L2 20h20L12 2z"
              stroke="#f59e0b"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              fill="#fef3c7"
            />
            <path
              d="M12 9v4M12 17h.01"
              stroke="#f59e0b"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </div>

        <div className="modal-message">
          <h3>Are you sure you want to select "No" for Require KYC?</h3>
          <p>
            If you select <strong>"No"</strong>, the KYC email will{" "}
            <strong>NOT</strong> be sent to the vendor's email address or SPOC
            email address.
          </p>
          <p className="warning-text">
            This means the vendor will not receive any KYC onboarding
            instructions or links.
          </p>
        </div>

        <div className="modal-actions">
          <button type="button" className="btn-cancel" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="btn-confirm" onClick={onConfirm}>
            Yes, Proceed Without KYC Email
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default RequireKycModal;
